// extracted by mini-css-extract-plugin
module.exports = {"related-articles-heading":"RelatedArticles-module--related-articles-heading--2kXwI","related-articles":"RelatedArticles-module--related-articles--2h1Ht"};